export const paymentStatusColor = (status: string): string => {
  switch (status) {
    case 'pending':
      return 'amber lighten-1';
    case 'confirmed':
      return 'green darken-2';
    case 'canceled':
      return 'deep-orange accent-4';
    case 'failed':
      return 'deep-orange accent-4';
    case 'rejected':
      return 'deep-orange accent-4';
    default:
      return 'light-blue darken-3';
  }
};